/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { CustomSearch } from './CustomSearch';
import {
    CustomSearchFromJSON,
    CustomSearchFromJSONTyped,
    CustomSearchToJSON,
} from './CustomSearch';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { EPrintingQueueStatusListSearch } from './EPrintingQueueStatusListSearch';
import {
    EPrintingQueueStatusListSearchFromJSON,
    EPrintingQueueStatusListSearchFromJSONTyped,
    EPrintingQueueStatusListSearchToJSON,
} from './EPrintingQueueStatusListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface PrintingQueueSearchDto
 */
export interface PrintingQueueSearchDto {
    /**
     * 
     * @type {EPrintingQueueStatusListSearch}
     * @memberof PrintingQueueSearchDto
     */
    status?: EPrintingQueueStatusListSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof PrintingQueueSearchDto
     */
    nomRapport?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof PrintingQueueSearchDto
     */
    displayName?: TextSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof PrintingQueueSearchDto
     */
    creationDate?: DateSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof PrintingQueueSearchDto
     */
    hidden?: BooleanSearch;
    /**
     * 
     * @type {CustomSearch}
     * @memberof PrintingQueueSearchDto
     */
    idapprenantAr?: CustomSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof PrintingQueueSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof PrintingQueueSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof PrintingQueueSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PrintingQueueSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof PrintingQueueSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof PrintingQueueSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the PrintingQueueSearchDto interface.
 */
export function instanceOfPrintingQueueSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PrintingQueueSearchDtoFromJSON(json: any): PrintingQueueSearchDto {
    return PrintingQueueSearchDtoFromJSONTyped(json, false);
}

export function PrintingQueueSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrintingQueueSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : EPrintingQueueStatusListSearchFromJSON(json['status']),
        'nomRapport': !exists(json, 'nomRapport') ? undefined : TextSearchFromJSON(json['nomRapport']),
        'displayName': !exists(json, 'displayName') ? undefined : TextSearchFromJSON(json['displayName']),
        'creationDate': !exists(json, 'creationDate') ? undefined : DateSearchFromJSON(json['creationDate']),
        'hidden': !exists(json, 'hidden') ? undefined : BooleanSearchFromJSON(json['hidden']),
        'idapprenantAr': !exists(json, 'idapprenantAr') ? undefined : CustomSearchFromJSON(json['idapprenantAr']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function PrintingQueueSearchDtoToJSON(value?: PrintingQueueSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': EPrintingQueueStatusListSearchToJSON(value.status),
        'nomRapport': TextSearchToJSON(value.nomRapport),
        'displayName': TextSearchToJSON(value.displayName),
        'creationDate': DateSearchToJSON(value.creationDate),
        'hidden': BooleanSearchToJSON(value.hidden),
        'idapprenantAr': CustomSearchToJSON(value.idapprenantAr),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

